import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axiosInstance';

export const fetchMedicalData = createAsyncThunk(
    'medical/fetchMedicalData',
    async (patientId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`getPatientDiseaseDetails/${patientId}`);
            if (response.data.success) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch medical data');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Error fetching medical data');
        }
    }
);

const medicalSlice = createSlice({
    name: 'medical',
    initialState: {
        allergies: [],
        chronic_illness: [],
        diagnosis: [],
        prescriptions: [],
        xray_reports: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMedicalData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMedicalData.fulfilled, (state, action) => {
                state.loading = false;
                state.allergies = action.payload.allergies || [];
                state.chronic_illness = action.payload.chronic_illness || [];
                state.diagnosis = action.payload.diagnosis || [];
                state.prescriptions = action.payload.prescriptions || [];
                state.xray_reports = action.payload.xray_reports || [];
            })
            .addCase(fetchMedicalData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default medicalSlice.reducer;
